/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type { AiAgentInferenceResponse } from '../model/aiAgentInferenceResponse';
import type { AiAgentPaymentRequestSuggestBody } from '../model/aiAgentPaymentRequestSuggestBody';
import type { BadRequestResponse } from '../model/badRequestResponse';
import type { ForbiddenResponse } from '../model/forbiddenResponse';
import type { NotFoundResponse } from '../model/notFoundResponse';
import type { UnauthorizedResponse } from '../model/unauthorizedResponse';
import type { UnprocessableEntityResponse } from '../model/unprocessableEntityResponse';
import { useCustomClient } from '../../mutator/custom-instance';
import type { ErrorType, BodyType } from '../../mutator/custom-instance';
import { customFomDataFn } from '../../api/formData/ai-agent-payment-request-suggest';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

/**
 * @summary AI Agent Payment Request Suggest
 */
export const useAiAgentPaymentRequestSuggestHook = () => {
  const aiAgentPaymentRequestSuggest =
    useCustomClient<AiAgentInferenceResponse>();

  return (
    aiAgentPaymentRequestSuggestBody: BodyType<AiAgentPaymentRequestSuggestBody>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    const formData = customFomDataFn(aiAgentPaymentRequestSuggestBody);
    return aiAgentPaymentRequestSuggest(
      {
        url: `/api/js/ai_agents/payment_requests/suggests`,
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
      },
      options
    );
  };
};

export const getAiAgentPaymentRequestSuggestQueryKey = (
  aiAgentPaymentRequestSuggestBody: AiAgentPaymentRequestSuggestBody
) => {
  return [
    `/api/js/ai_agents/payment_requests/suggests`,
    aiAgentPaymentRequestSuggestBody,
  ] as const;
};

export const useAiAgentPaymentRequestSuggestQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAiAgentPaymentRequestSuggestHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  aiAgentPaymentRequestSuggestBody: AiAgentPaymentRequestSuggestBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useAiAgentPaymentRequestSuggestHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAiAgentPaymentRequestSuggestQueryKey(aiAgentPaymentRequestSuggestBody);

  const aiAgentPaymentRequestSuggest = useAiAgentPaymentRequestSuggestHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useAiAgentPaymentRequestSuggestHook>>>
  > = () =>
    aiAgentPaymentRequestSuggest(
      aiAgentPaymentRequestSuggestBody,
      requestOptions
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAiAgentPaymentRequestSuggestHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AiAgentPaymentRequestSuggestQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAiAgentPaymentRequestSuggestHook>>>
>;
export type AiAgentPaymentRequestSuggestQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary AI Agent Payment Request Suggest
 */
export const useAiAgentPaymentRequestSuggest = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAiAgentPaymentRequestSuggestHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  aiAgentPaymentRequestSuggestBody: AiAgentPaymentRequestSuggestBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useAiAgentPaymentRequestSuggestHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useAiAgentPaymentRequestSuggestQueryOptions(
    aiAgentPaymentRequestSuggestBody,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAiAgentPaymentRequestSuggestSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAiAgentPaymentRequestSuggestHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  aiAgentPaymentRequestSuggestBody: AiAgentPaymentRequestSuggestBody,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useAiAgentPaymentRequestSuggestHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAiAgentPaymentRequestSuggestQueryKey(aiAgentPaymentRequestSuggestBody);

  const aiAgentPaymentRequestSuggest = useAiAgentPaymentRequestSuggestHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useAiAgentPaymentRequestSuggestHook>>>
  > = () =>
    aiAgentPaymentRequestSuggest(
      aiAgentPaymentRequestSuggestBody,
      requestOptions
    );

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAiAgentPaymentRequestSuggestHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AiAgentPaymentRequestSuggestSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAiAgentPaymentRequestSuggestHook>>>
>;
export type AiAgentPaymentRequestSuggestSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary AI Agent Payment Request Suggest
 */
export const useAiAgentPaymentRequestSuggestSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAiAgentPaymentRequestSuggestHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  aiAgentPaymentRequestSuggestBody: AiAgentPaymentRequestSuggestBody,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useAiAgentPaymentRequestSuggestHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useAiAgentPaymentRequestSuggestSuspenseQueryOptions(
    aiAgentPaymentRequestSuggestBody,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
